"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
const Icon_1 = require("../Icon");
require("./index.scss");
const className = 'notification';
class Notification extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isClosed: false,
        };
        this.onClose = () => {
            var _a, _b;
            this.setState({
                isClosed: true,
            });
            (_b = (_a = this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.rootElement = (0, react_1.createRef)();
    }
    componentDidMount() {
        if (this.props.timeout) {
            setTimeout(() => {
                this.onClose();
            }, this.props.timeout);
        }
        if (this.props.scrollIntoView) {
            this.rootElement.current.scrollIntoView({ behavior: 'smooth' });
        }
    }
    render() {
        const { icon, title, text, modificators, hideCloseButton } = this.props;
        const { isClosed } = this.state;
        const classNames = (0, classFunctions_1.getClassNames)(className, [
            modificators,
            isClosed ? 'hidden' : undefined,
        ]);
        return (react_1.default.createElement("div", { className: classNames, ref: this.rootElement },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: icon })),
                title && (react_1.default.createElement("div", { className: `${className}__title` },
                    title,
                    ":")),
                react_1.default.createElement("div", { className: `${className}__text` }, text),
                !hideCloseButton && (react_1.default.createElement("div", { className: `${className}__close` },
                    react_1.default.createElement("button", { onClick: this.onClose, role: 'button' },
                        react_1.default.createElement(Icon_1.Icon, { name: 'x' })))))));
    }
}
exports.Notification = Notification;
Notification.defaultProps = {
    icon: 'info',
    title: '',
    text: '',
};
//# sourceMappingURL=index.js.map